import NotFoundPage from '../js/pages/NotFoundPage';

export default NotFoundPage;
